import styled from "styled-components";

export const StyledCommentSectionContainer = styled.div`
  padding: ${({ theme: { space = {} } }) => space.xs} 0px;

  #lockSummary-textWrapper {
    word-break: break-word;
  }
`;
